import clsx from "clsx";
import { type JSX, useState } from "react";

import PoweredByStripe from "common/components/PoweredByStripe";
import { Button } from "common/components/ui/Button";
import { DrawerTitle } from "common/components/ui/Drawer";
import type { SubscriptionType } from "common/types";

export default function MobileLayout({
  subscriptionType,
  subscriptionPlanComponent,
  pricingPeriodSelectionComponent,
  currentEstimateComponent,
  quantitySelectionComponent,
  pricingComponent,
  paymentSourceComponent,
  subscriptionActionButton,
  estimateComponents,
  errorMessageComponent,
  isPaymentPreviousStep,
}: {
  subscriptionType: SubscriptionType;
  subscriptionPlanComponent: JSX.Element;
  pricingPeriodSelectionComponent: JSX.Element;
  currentEstimateComponent: JSX.Element | undefined;
  quantitySelectionComponent: JSX.Element;
  pricingComponent: JSX.Element;
  paymentSourceComponent: JSX.Element;
  subscriptionActionButton: JSX.Element;
  estimateComponents: JSX.Element;
  errorMessageComponent: JSX.Element;
  isPaymentPreviousStep: boolean;
}) {
  const [currentStep, setCurrentStep] = useState<"summary" | "manage">(
    isPaymentPreviousStep ? "summary" : "manage",
  );

  return (
    <>
      <DrawerTitle className="mb-4 capitalize">{currentStep}</DrawerTitle>
      {currentStep === "manage" ? (
        <>
          <div
            className={clsx(
              "flex flex-col rounded-5xl mb-6",
              subscriptionType === "user"
                ? "bg-[linear-gradient(332deg,_rgba(255,229,204,0.50)_2.81%,_rgba(249,250,251,0.50)_98.16%)]"
                : "bg-[linear-gradient(332deg,_rgba(219,220,255,0.50)_2.81%,_rgba(249,250,251,0.50)_98.16%)]",
            )}
          >
            <div className="p-6">{subscriptionPlanComponent}</div>
            {currentEstimateComponent && (
              <div className="px-4 pb-4">{currentEstimateComponent}</div>
            )}
          </div>
          {pricingPeriodSelectionComponent}
          <div className="rounded-5xl flex flex-col bg-black-50 pb-1.5 gap-y-2.5">
            {quantitySelectionComponent}
            {pricingComponent}
          </div>
          <Button
            size="lg"
            className="ml-auto mt-8"
            onClick={() => setCurrentStep("summary")}
          >
            Next
          </Button>
        </>
      ) : (
        <>
          {paymentSourceComponent}
          <div className="flex flex-col gap-y-3 mb-4 mt-6">
            <div className="bg-whiteGray flex flex-col gap-y-2.5 pb-2.5 rounded-4xl p-2">
              {currentEstimateComponent}
              {estimateComponents}
            </div>
            {errorMessageComponent}
          </div>
          <PoweredByStripe />
          <div className="mt-8 justify-between flex">
            <Button
              size="lg"
              variant="secondary-black"
              onClick={() => setCurrentStep("manage")}
            >
              Back
            </Button>
            {subscriptionActionButton}
          </div>
        </>
      )}
    </>
  );
}
